import styled from 'styled-components';

export const RowBlock = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  .column-block-left {
    width: 50%;
    text-align: left;
  }

  .column-block-right {
    width: 49%;
    text-align: right;
  }
`;
